<div class="z-40" [ngClass]="{ 'dark text-white-dark': store()?.semidark && store()?.menu === 'horizontal'}">
    <div class="relative flex w-full items-center px-5 py-3.5">
        <div class="horizontal-logo flex max-h-12 items-center justify-between ltr:mr-2 rtl:ml-2 lg:hidden">
            <a routerLink="/" class="main-logo flex h-10 shrink-0 items-center overflow-hidden">
                <img class="tenant-brand-logo ltr:-ml-1 rtl:-mr-1" [src]="branding.logoUrl()" alt="" />
            </a>

            <a href="javascript:;"
                class="collapse-icon flex flex-none rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary ltr:ml-2 rtl:mr-2 dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-primary lg:hidden"
                (click)="storeData.dispatch({type: 'toggleSidebar'})">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 7L4 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                    <path opacity="0.5" d="M20 12L4 12" stroke="currentColor" stroke-width="1.5"
                        stroke-linecap="round" />
                    <path d="M20 17L4 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                </svg>
            </a>
        </div>
        <div
            class="flex items-center justify-end space-x-1.5 ltr:ml-auto rtl:mr-auto rtl:space-x-reverse dark:text-[#d0d2d6] sm:flex-1 ltr:sm:ml-0 sm:rtl:mr-0 lg:space-x-2">
            <div class="flex items-center space-x-1.5 dark:text-[#d0d2d6] lg:space-x-2">
                <!-- horizontal menu -->
                <ul
                    class="horizontal-menu rounded-full hidden border-t border-[#ebedf2] bg-white font-normal text-black rtl:space-x-reverse dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white-dark lg:space-x-0.5 xl:space-x-0.5">
                    <li class="menu nav-item relative">
                        <a routerLink="/dashboard" class="nav-link" [class.active]="isMenuActive('/dashboard', true)">
                            <div class="flex items-center">
                                <icon-layout-grid class="size-8 shrink-0" />

                                <span class="px-2">{{ 'Dashboard' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    @if ((slugs.PD_LIST | hasPermission)) {
                    <li class="menu nav-item relative">
                        <a routerLink="/pd-list" class="nav-link" [class.active]="isMenuActive('/pd-list')">
                            <div class="flex items-center">
                                <icon-menu-notes class="size-8 shrink-0" />

                                <span class="px-2">{{'PD List' | translate}}</span>
                            </div>
                        </a>
                    </li>
                    }

                    @if ((slugs.PD_LINKS | hasPermission)) {
                    <li class="menu nav-item relative">
                        <a routerLink="/pd-links" class="nav-link" [class.active]="isMenuActive('/pd-links')">
                            <div class="flex items-center">
                                <icon-link class="size-8 shrink-0" />

                                <span class="px-2">{{ 'PD Link' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }

                    @if ((slugs.USER_LIST | hasPermission)) {
                    <li class="menu nav-item relative">
                        <a routerLink="/manage-user" class="nav-link" [class.active]="isMenuActive('/manage-user')">
                            <div class="flex items-center">
                                <icon-menu-users class="size-8 shrink-0" />

                                <span class="px-2">{{ 'Manage Users' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }

                    @if ((slugs.BILLING | hasPermission)) {
                    <li class="menu nav-item relative">
                        <a routerLink="/billing" class="nav-link" [class.active]="isMenuActive('/billing')">
                            <div class="flex items-center">
                                <icon-dollar-sign-circle class="size-8 shrink-0" />

                                <span class="px-2">{{ 'Billing' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }

                    @if ((slugs.BILLING | hasPermission)) {
                    <li class="menu nav-item relative">
                        <a routerLink="/payment-transactions" class="nav-link"
                            [class.active]="isMenuActive('/payment-transactions')">
                            <div class="flex items-center">
                                <icon-credit-card class="size-8 shrink-0" />

                                <span class="px-2">{{ 'Payments' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }

                    @if ((slugs.RULE_PACK_LIST | hasPermission)) {
                    <li class="menu nav-item relative">
                        <a routerLink="/rule-packs" class="nav-link" [class.active]="isMenuActive('/rule-packs')">
                            <div class="flex items-center">
                                <icon-list-check class="size-8 shrink-0" />

                                <span class="px-2">{{ 'Rule Packs' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }

                    @if ((slugs.AUDIT_TRAIL_LIST | hasPermission)) {
                    <li class="menu nav-item relative">
                        <a routerLink="/audit-trail" class="nav-link" [class.active]="isMenuActive('/audit-trail')">
                            <div class="flex items-center">
                                <icon-clipboard-text class="size-8 shrink-0" />

                                <span class="px-2">{{'Audit Trail' | translate}}</span>
                            </div>
                        </a>
                    </li>
                    }

                </ul>

                <div class="dropdown shrink-0">
                    <div hlMenu>
                        <button type="button" hlMenuButton
                            class="relative block rounded-full bg-white shadow-md p-2.5 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60">
                            <icon-bell-bing class="size-6 shrink-0" />

                            @if ((unreadCount$ | async)! > 0) {
                            <span class="absolute top-0 flex h-3 w-3 ltr:right-0 rtl:left-0">
                                <span
                                    class="absolute -top-[3px] inline-flex h-full w-full animate-ping rounded-full bg-success/50 opacity-75 ltr:-left-[3px] rtl:-right-[3px]"></span>
                                <span class="relative inline-flex h-[6px] w-[6px] rounded-full bg-success"></span>
                            </span>
                            }
                        </button>
                        <ul *hlMenuItems animate.enter="ap-toggle-enter" animate.leave="ap-toggle-leave"
                            class="top-11 w-[300px] divide-y !py-0 text-dark ltr:-right-2 rtl:-left-2 dark:divide-white/10 dark:text-white-dark sm:w-[350px]">
                            <li>
                                <div class="flex items-center justify-between px-4 py-2 font-semibold">
                                    <h4 class="text-lg">Notifications</h4>
                                    @if ((unreadCount$ | async)! > 0) {
                                    <span class="badge bg-primary/80">{{ (unreadCount$ | async) }} New</span>
                                    }
                                </div>
                            </li>
                            @for (notification of (notifications$ | async); track notification.id) {
                            <li class="dark:text-white-light/90">
                                <div class="group flex items-start px-4 py-3 gap-3">
                                    <!-- System alert icon -->
                                    <div class="flex-none mt-0.5">
                                        <span
                                            class="grid place-content-center w-9 h-9 rounded-full bg-primary/10 text-primary">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24"
                                                fill="none" stroke="currentColor" stroke-width="1.5"
                                                stroke-linecap="round" stroke-linejoin="round">
                                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                                            </svg>
                                        </span>
                                    </div>
                                    <div class="flex-1 min-w-0">
                                        <p class="text-sm font-semibold truncate">{{ notification.title }}</p>
                                        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5 line-clamp-2">{{
                                            notification.message }}</p>
                                        <span class="block text-xs font-normal text-gray-400 dark:text-gray-500 mt-1">
                                            {{ notification.created_at | date:'short' }}
                                        </span>
                                    </div>
                                    <button type="button"
                                        class="text-neutral-300 opacity-0 hover:text-danger group-hover:opacity-100 flex-none ltr:ml-auto rtl:mr-auto"
                                        (click)="dismissNotification(notification.id, $event)">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle opacity="0.5" cx="12" cy="12" r="10" stroke="currentColor"
                                                stroke-width="1.5" />
                                            <path d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5" stroke="currentColor"
                                                stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </button>
                                </div>
                            </li>
                            }
                            @if ((unreadCount$ | async)! > 0) {
                            <li>
                                <div class="p-4">
                                    <button type="button"
                                        class="btn bg-[#303030] text-white rounded-full dark:bg-[#191e3a] block w-full"
                                        *hlMenuItem="let menuItem" (click)="clearAllNotifications()">Mark All
                                        Read</button>
                                </div>
                            </li>
                            }
                            @if ((unreadCount$ | async) === 0) {
                            <li>
                                <div class="!grid min-h-[200px] place-content-center text-lg hover:!bg-transparent">
                                    <div class="mx-auto mb-4 rounded-full text-primary ring-4 ring-primary/30">
                                        <svg width="40" height="40" viewBox="0 0 20 20" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.5"
                                                d="M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z"
                                                fill="currentColor" />
                                            <path
                                                d="M10 4.25C10.4142 4.25 10.75 4.58579 10.75 5V11C10.75 11.4142 10.4142 11.75 10 11.75C9.58579 11.75 9.25 11.4142 9.25 11V5C9.25 4.58579 9.58579 4.25 10 4.25Z"
                                                fill="currentColor" />
                                            <path
                                                d="M10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15Z"
                                                fill="currentColor" />
                                        </svg>
                                    </div>
                                    No unread notifications.
                                </div>
                            </li>
                            }
                            <li class="border-t border-white-light dark:border-white-light/10">
                                <a routerLink="/notifications"
                                    class="block w-full px-4 py-3 text-center text-sm font-semibold text-primary hover:bg-gray-50 dark:hover:bg-white/5">
                                    View all notifications
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="dropdown shrink-0">
                    <div hlMenu class="!block">
                        <button type="button" hlMenuButton class="group relative block"
                            [attr.aria-label]="profileState.userDisplay().name || 'User menu'">
                            @if (profileState.userDisplay().avatarUrl) {
                            <img [src]="profileState.userDisplay().avatarUrl"
                                class="h-[49px] w-[49px] rounded-full object-cover border-[4px] border-white saturate-50 group-hover:saturate-100"
                                alt="" />
                            } @else {
                            <span
                                class="flex h-[49px] w-[49px] items-center justify-center rounded-full border-[4px] border-white bg-primary/20 text-sm font-bold text-primary saturate-50 group-hover:saturate-100">{{
                                profileState.userDisplay().initials }}</span>
                            }
                        </button>
                        <ul *hlMenuItems animate.enter="ap-toggle-enter" animate.leave="ap-toggle-leave"
                            class="top-11 w-[230px] !py-0 font-normal text-dark ltr:right-0 rtl:left-0 dark:text-white-dark dark:text-white-light/90">
                            <li>
                                <div class="flex items-center px-4 py-4">
                                    <div class="flex-none">
                                        @if (profileState.userDisplay().avatarUrl) {
                                        <img [src]="profileState.userDisplay().avatarUrl"
                                            class="h-10 w-10 rounded-md object-cover" alt="" />
                                        } @else {
                                        <span
                                            class="flex h-10 w-10 items-center justify-center rounded-md bg-primary/10 text-sm font-bold text-primary">{{
                                            profileState.userDisplay().initials
                                            }}</span>
                                        }
                                    </div>
                                    <div class="truncate ltr:pl-4 rtl:pr-4">
                                        <h4 class="text-base">
                                            {{ profileState.userDisplay().name || 'User' }}
                                        </h4>
                                        @if (profileState.userDisplay().role) {
                                        <span
                                            class="mt-0.5 inline-block rounded-full bg-primary/10 px-2 py-px text-[11px] font-medium text-primary">{{
                                            profileState.userDisplay().role }}</span>
                                        }
                                        <span class="block text-black/60 text-sm dark:text-dark-light/60">{{
                                            profileState.userDisplay().email }}</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <a routerLink="/profile" *hlMenuItem="let menuItem" class="dark:hover:text-white">
                                    <svg class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" width="18" height="18"
                                        viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12" cy="6" r="4" stroke="currentColor" stroke-width="1.5" />
                                        <path opacity="0.5"
                                            d="M20 17.5C20 19.9853 20 22 12 22C4 22 4 19.9853 4 17.5C4 15.0147 7.58172 13 12 13C16.4183 13 20 15.0147 20 17.5Z"
                                            stroke="currentColor" stroke-width="1.5" />
                                    </svg>

                                    Profile
                                </a>
                            </li>
                            <li>
                                <a routerLink="/integrations" *hlMenuItem="let menuItem" class="dark:hover:text-white">
                                    <svg class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" width="18" height="18"
                                        viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                                        <path opacity="0.5" d="M2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                                    </svg>
                                    Integrations
                                </a>
                            </li>
                            @if ((slugs.MANAGE_AGENT | hasPermission)) {
                            <li>
                                <a routerLink="/manage-agent" *hlMenuItem="let menuItem" class="dark:hover:text-white">
                                    <icon-cpu-bolt class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" />
                                    Manage Agents
                                </a>
                            </li>
                            }
                            @if (canAccessSystemPreferences) {
                            <li>
                                <a routerLink="/system-preferences" *hlMenuItem="let menuItem" class="dark:hover:text-white">
                                    <svg class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" width="18" height="18"
                                        viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                                            stroke="currentColor"
                                            d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 011.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.56.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.893.149c-.425.07-.765.383-.93.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 01-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.397.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 01-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204-.165-.397-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.107-1.204l-.527-.738a1.125 1.125 0 01.12-1.45l.773-.773a1.125 1.125 0 011.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71.505.78-.929l.15-.894z" />
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                                            stroke="currentColor" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                    System Preferences
                                </a>
                            </li>
                            }
                            @if (showSubscriptionsMenu && (slugs.SUBSCRIPTION_LIST | hasPermission)) {
                            <li>
                                <a routerLink="/subscriptions" *hlMenuItem="let menuItem" class="dark:hover:text-white">
                                    <svg class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" width="18" height="18"
                                        viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                                            stroke="currentColor"
                                            d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
                                    </svg>
                                    Subscriptions
                                </a>
                            </li>
                            }
                            <li class="border-t border-white-light dark:border-white-light/10">
                                <a href="javascript:;" *hlMenuItem="let menuItem" class="!py-3 text-danger"
                                    (click)="$event.preventDefault(); signOut()">
                                    <svg class="h-4.5 w-4.5 shrink-0 rotate-90 ltr:mr-2 rtl:ml-2" width="18" height="18"
                                        viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.5"
                                            d="M17 9.00195C19.175 9.01406 20.3529 9.11051 21.1213 9.8789C22 10.7576 22 12.1718 22 15.0002V16.0002C22 18.8286 22 20.2429 21.1213 21.1215C20.2426 22.0002 18.8284 22.0002 16 22.0002H8C5.17157 22.0002 3.75736 22.0002 2.87868 21.1215C2 20.2429 2 18.8286 2 16.0002L2 15.0002C2 12.1718 2 10.7576 2.87868 9.87889C3.64706 9.11051 4.82497 9.01406 7 9.00195"
                                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                                        <path d="M12 15L12 2M12 2L15 5.5M12 2L9 5.5" stroke="currentColor"
                                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    Sign Out
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>